import { useTranslation } from 'react-i18next';

import { useLocale } from '../../hooks/useLocale';
import type { BingoCoinType } from '../../stores/bingo/types';
import { formatValueWithK } from '../../utils/helpers';
import { SocialCoin } from '../SocialCoin/SocialCoin';

import styles from './LobbyPassBanner.module.scss';

interface BannerResultProps {
  titleText: string;
  bingoResultToShow: { coinType: BingoCoinType; totalUserReward: number; gameId: string };
}

export const BannerResult = ({ titleText, bingoResultToShow }: BannerResultProps) => {
  const { t } = useTranslation();
  const { localeCurrency } = useLocale();
  const { coinType, totalUserReward } = bingoResultToShow;

  return (
    <span className={styles.titleText}>
      {titleText}
      {coinType === 'GC' ? (
        <span className={styles.ccReward}>
          <SocialCoin className={styles.socialCoinIcon} />
          <span className={styles.amount}>{formatValueWithK(totalUserReward, t)}</span>
        </span>
      ) : (
        <span className={styles.cashReward}>
          <span className={styles.amount}>{localeCurrency(totalUserReward)}</span>
        </span>
      )}
    </span>
  );
};
